<ng-container *ngIf="subscriptionItemService.cartItems.value.length > 0">
	<div class="d-flex ms-auto me-2 clickable">
		<p-button pRipple styleClass="oo-cart-button p-button-raised p-button-success m-2" (click)="displayCart = true">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'shopping-cart']" size="lg" class="ms-1 me-2"></fa-icon>
					<span *ngIf="!app.deviceService.isMobile()" class="me-1">View Order</span>
					{{ subscriptionItemService.cartItems.value.length }} Items
				</div>
			</ng-template>
		</p-button>
	</div>
</ng-container>

<div *ngIf="!ooVenue">
	<div class="w-100 h-100 d-flex">
		<div class="animation-heartbeat animation-count-infinite h1 mx-auto my-auto">Loading...</div>
	</div>
</div>
<div class="core">
	<div *ngIf="venueService.ooVenue?.name" style="max-width: 1200px" class="d-flex w-100 mx-auto">
		<div class="d-flex flex-column mx-auto">
			<app-venue-header [ooVenue]="ooVenue"></app-venue-header>
			<div class="mx-auto" [style.background-color]="ooVenue.styles?.menuBgColor">
				<app-subscription-menu></app-subscription-menu>
				<app-subscription-checkout
					*ngIf="displayCart"
					(displayCartChange)="displayCart = $event"
					[displayCart]="displayCart"
				></app-subscription-checkout>
			</div>
		</div>
	</div>
	<div class="footer-content">
		<div class="mx-auto">
			<app-terms-of-service-footer></app-terms-of-service-footer>
		</div>
	</div>
</div>
